export enum BoostFarmModalStep {
  SELECT_BOOST_FARM = 0,
  CONFIRM_BOOST = 1,
}
